module.exports = "https://qp-assets.quero.com/assets/images/landing/green-oval.svg?848366442f770802d065659279cc2805";